module.exports = __webpack_public_path__ + "static/media/v11m.63cadfaa.mp4";